var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unlock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.66667 7.33333V4.66666C4.66584 3.84003 4.97219 3.04257 5.52625 2.42911C6.08031 1.81564 6.84255 1.42993 7.665 1.34685C8.48745 1.26378 9.31143 1.48926 9.97698 1.97954C10.6425 2.46981 11.1022 3.18989 11.2667 4M3.33333 7.33333H12.6667C13.403 7.33333 14 7.93028 14 8.66666V13.3333C14 14.0697 13.403 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0697 2 13.3333V8.66666C2 7.93028 2.59695 7.33333 3.33333 7.33333Z",
    stroke: "#DD2732",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.0c45f3d4aab22d04c72d1409fc28ebb9.svg";
export { ForwardRef as ReactComponent };